<template>
  <div class="delivery-track-wrapper bj" v-loading="loading">
    <div class="track-content">
      <div class="track-column" v-for="(item, key) in trackData" :key="key">
        <h2 class="column-header">
          {{ item.is_morning === 1 ? '早市仓' + ( '（' + item.morning_time + `前` + '）' ) :  '午市仓' }}
        </h2>
        <!-- 品控进度 -->
        <el-card class="track-card" shadow="hover">
          <div class="card-title">品控进度</div>
          <div class="progress-section">
            <span class="percent-num">{{ calculatePercent(item.partial_num, item.total_num) }}%</span>
            <div class="progress-bar">
              <el-progress
                :percentage="calculatePercent(item.partial_num, item.total_num)"
                :show-text="false"
                :stroke-width="12"
                color="#409EFF"
              >
              </el-progress>
            </div>
          </div>
          <div class="data-row">
            <div class="data-item">
              共：<span class="num">{{ item.total_num || 0 }}</span> 件
            </div>
            <div class="data-item">
              已品控：<span class="num">{{ item.partial_num || 0 }}</span> 件
            </div>
          </div>
        </el-card>

        <!-- 复核进度 -->
        <el-card class="track-card" shadow="hover">
          <div class="card-title">复核进度</div>
          <div class="progress-section">
            <span class="percent-num">{{ calculatePercent(item.qc_number, item.total_num) }}%</span>
            <div class="progress-bar">
              <el-progress
                :percentage="calculatePercent(item.qc_number, item.total_num)"
                :show-text="false"
                :stroke-width="12"
                color="#409EFF"
              >
              </el-progress>
            </div>
          </div>
          <div class="data-row">
            <div class="data-item">
              共：<span class="num">{{ item.total_num || 0 }}</span> 件
            </div>
            <div class="data-item">
              已品控：<span class="num">{{ parseNumber(item.qc_number) }}</span> 件
            </div>
          </div>
          <div class="data-row mt-10">
            <div class="data-item">
              共：<span class="num">{{ item.supplier_order_count || 0 }}</span> 单
            </div>
            <div class="data-item">
              已品控：<span class="num">{{ item.qc_count || 0 }}</span> 单
            </div>
          </div>
        </el-card>

        <!-- 超时未送货 -->
        <el-card class="track-card" shadow="hover">
          <div class="card-title">超 2 小时未送货</div>
          <div class="progress-section">
            <span class="percent-num">{{ calculatePercent(item.quality_control_count, item.supplier_order_count) }}%</span>
            <div class="progress-bar">
              <el-progress
                :percentage="calculatePercent(item.quality_control_count, item.supplier_order_count)"
                :show-text="false"
                :stroke-width="12"
                color="#409EFF"
              >
              </el-progress>
            </div>
          </div>
          <div class="data-row">
            <div class="data-item">
              共：<span class="num">{{ item.supplier_order_count || 0 }}</span> 单
            </div>
            <div class="data-item danger">
              超时：<span class="num">{{ item.quality_control_count || 0 }}</span>
              单
            </div>
          </div>
          <div class="data-row mt-10">
            <div class="data-item">
              共：<span class="num">{{ item.total_num || 0 }}</span> 件
            </div>
            <div class="data-item danger">
              超时：<span class="num">{{ parseNumber(item.quality_control_num) }}</span>
              件
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getDeliveryProgress } from "@/api/logisticsControl/delivery/index";

export default {
  name: "delivery-track",
  data() {
    return {
      loading: false,
      trackData: {
        morning: {
          is_morning: 1,
          total_num: 0,
          partial_num: 0,
          qc_number: 0,
          qc_count: 0,
          supplier_order_count: 0,
          quality_control_count: 0,
          quality_control_num: 0,
          morning_time: "",
        },
        afternoon: {
          is_morning: 0,
          total_num: 0,
          partial_num: 0,
          qc_number: 0,
          qc_count: 0,
          supplier_order_count: 0,
          quality_control_count: 0,
          quality_control_num: 0,
          morning_time: "",
        },
      },
    };
  },
  created() {
    this.hqlist();
  },
  methods: {
    async hqlist() {
      this.loading = true;
      try {
        const res = await getDeliveryProgress();
        const { morning, afternoon } = res.data || {};
        if (morning) this.trackData.morning = { ...this.trackData.morning, ...morning };
        if (afternoon) this.trackData.afternoon = { ...this.trackData.afternoon, ...afternoon };
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    parseNumber(val) {
      if (!val) return 0;
      return Number(String(val).replace(/,/g, "")) || 0;
    },
    calculatePercent(numerator, denominator) {
      const num = this.parseNumber(numerator);
      const den = this.parseNumber(denominator);
      if (!den) return 0;
      return Math.round((num / den) * 100);
    }
  },
};
</script>

<style lang="scss" scoped>
.delivery-track-wrapper {
  box-sizing: border-box;
  margin: 10px;
  background-color: #fff;
  overflow-y: auto;

  .track-content {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    gap: 40px;
    max-width: 1400px;
    margin: 20px auto;
  }

  .track-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .column-header {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      text-align: center;
      margin-bottom: 10px;
    }
  }

  .track-card {
    border-radius: 8px;
    border: 1px solid #e4e7ed;

    ::v-deep .el-card__body {
      padding: 25px;
    }

    .card-title {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      margin-bottom: 15px;
    }

    .progress-section {
      display: flex;
      align-items: center;
      margin-bottom: 25px;

      .percent-num {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        width: 60px;
      }

      .progress-bar {
        flex: 1;
        margin-left: 10px;
      }
    }

    .data-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #333;
      font-weight: 500;

      &.mt-10 {
        margin-top: 15px;
      }

      .data-item {
        flex: 1;

        &:last-child {
          text-align: right;
        }

        .num {
          font-weight: bold;
          font-size: 15px;
          margin: 0 4px;
        }

        &.danger {
          color: #ff4949;

          .num {
            color: #ff4949;
          }
        }
      }
    }
  }
}
</style>
